module.exports = __webpack_public_path__ + "img/2.faebced2.png";